export default "__VITE_ASSET__CmjX4d5n__"